module.exports = __webpack_public_path__ + "img/sun.5a0cc24f.svg";